<template>
  <PrimevueDialog
    :visible="visible"
    :modal="true"
    :style="{ width: '760px', maxWidth: '96vw' }"
    :closable="!saving"
    header="Prix fournisseur modifiés"
    @update:visible="$emit('update:visible', $event)"
  >
    <div class="mb-3">
      <p class="mb-1 fw-semibold">
        Certains prix de cette commande sont différents des prix enregistrés pour ce fournisseur.
      </p>
      <p class="small text-muted mb-0">
        Choisissez les produits dont le prix fournisseur de référence doit être mis à jour avant de valider le stock.
      </p>
    </div>

    <div class="table-responsive border rounded">
      <table class="table table-sm align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th style="width: 44px;"></th>
            <th>Produit</th>
            <th class="text-end">Ancien prix</th>
            <th class="text-end">Prix commande</th>
            <th class="text-end">Écart</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="change in changes" :key="change.purchase_item_id || change.product_id">
            <td class="text-center">
              <input
                v-model="selectedProductIds"
                class="form-check-input"
                type="checkbox"
                :value="change.product_id"
                :disabled="saving"
              />
            </td>
            <td>
              <div class="fw-semibold">{{ change.product_name }}</div>
              <div class="small text-muted">
                {{ change.product_sku || 'Sans référence' }}
                <span v-if="!change.has_supplier_offer" class="badge bg-info-subtle text-info-emphasis ms-2">
                  Nouveau lien fournisseur
                </span>
              </div>
            </td>
            <td class="text-end">
              <span v-if="change.old_price !== null && typeof change.old_price !== 'undefined'">
                {{ $format.currency(change.old_price) }}
              </span>
              <span v-else class="text-muted">-</span>
            </td>
            <td class="text-end fw-semibold">
              {{ $format.currency(change.new_price || 0) }}
            </td>
            <td class="text-end" :class="differenceClass(change)">
              {{ formatDifference(change) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <template #footer>
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        :disabled="saving"
        @click="confirmWithoutPriceUpdate"
      >
        <i class="fa fa-check me-1" aria-hidden="true"></i>
        Valider sans changer les prix
      </button>
      <button
        type="button"
        class="btn btn-primary btn-sm"
        :disabled="saving"
        @click="confirmWithPriceUpdate"
      >
        <i class="fa fa-check me-1"></i>
        Valider et mettre à jour les prix sélectionnés
      </button>
    </template>
  </PrimevueDialog>
</template>

<script>
export default {
  name: 'SupplierPriceChangesDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    changes: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:visible', 'confirm'],
  data() {
    return {
      selectedProductIds: [],
    };
  },
  watch: {
    changes: {
      immediate: true,
      handler(changes) {
        this.selectedProductIds = (changes || []).map((change) => change.product_id);
      },
    },
  },
  methods: {
    confirmWithoutPriceUpdate() {
      this.$emit('confirm', {
        updateSupplierPrices: false,
        productIds: [],
      });
    },

    confirmWithPriceUpdate() {
      this.$emit('confirm', {
        updateSupplierPrices: true,
        productIds: this.selectedProductIds.map((productId) => Number(productId)),
      });
    },

    differenceClass(change) {
      const difference = Number(change.difference || 0);

      if (difference > 0) {
        return 'text-danger';
      }

      if (difference < 0) {
        return 'text-success';
      }

      return 'text-muted';
    },

    formatDifference(change) {
      const difference = Number(change.difference || 0);
      const formatted = this.$format.currency(Math.abs(difference));

      if (difference > 0) {
        return `+${formatted}`;
      }

      if (difference < 0) {
        return `-${formatted}`;
      }

      return formatted;
    },
  },
};
</script>
